export const getPendingSessionsEndpoint =
  'movimenti-conto-ms/ms/session/retrievePendingSessions';
